import loadable from '@loadable/component';

// 懒加载组件
const SmsRecordQuery = loadable(() => import('./smsRecordQuery/SmsRecordQuery'));

export const subRoutes = [
  {
    path: '/SmsRecordQuery',
    component: SmsRecordQuery
  }
];
